import React, { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { grantConsent, denyConsent, getConsent } from "@/lib/analytics";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Only show if the user has not yet made a choice
    if (!getConsent()) {
      const t = setTimeout(() => setVisible(true), 700);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    grantConsent();
    setVisible(false);
  };

  const refuse = () => {
    denyConsent();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label="Préférences cookies"
      className="fixed inset-x-3 bottom-3 z-[60] sm:inset-x-auto sm:bottom-6 sm:left-6 sm:right-6 sm:mx-auto sm:max-w-3xl"
    >
      <div className="overflow-hidden rounded-2xl border border-stone-200 bg-white shadow-[0_24px_60px_-20px_rgba(28,25,23,0.35)]">
        <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:gap-6 sm:p-6">
          <div className="flex items-start gap-3 sm:items-center">
            <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-orange-50 text-orange-800">
              <Cookie className="h-5 w-5" strokeWidth={1.5} />
            </span>
            <div className="text-sm leading-relaxed text-stone-700">
              <p className="font-medium text-stone-900">
                Quelques cookies pour mieux vous accompagner&nbsp;?
              </p>
              <p className="mt-1 text-stone-600">
                Nous utilisons des cookies pour mesurer l'audience et améliorer
                votre expérience. Vos données restent confidentielles —{" "}
                <Link
                  to="/confidentialite"
                  className="underline decoration-stone-300 underline-offset-2 hover:text-orange-800"
                >
                  en savoir plus
                </Link>.
              </p>
            </div>
          </div>

          <div className="flex shrink-0 items-center justify-end gap-2 sm:flex-row">
            <Button
              data-testid="cookie-refuse"
              variant="ghost"
              onClick={refuse}
              className="h-10 rounded-full px-5 text-sm text-stone-600 hover:bg-stone-100 hover:text-stone-900"
            >
              Refuser
            </Button>
            <Button
              data-testid="cookie-accept"
              onClick={accept}
              className="h-10 rounded-full bg-stone-900 px-5 text-sm text-stone-50 hover:bg-orange-800"
            >
              Accepter
            </Button>
            <button
              data-testid="cookie-close"
              onClick={refuse}
              aria-label="Fermer"
              className="hidden h-10 w-10 items-center justify-center rounded-full text-stone-400 hover:bg-stone-100 hover:text-stone-700 sm:inline-flex"
            >
              <X className="h-4 w-4" strokeWidth={1.5} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
